import { render, staticRenderFns } from "./SignupNew.vue?vue&type=template&id=10127a46&scoped=true&"
import script from "./SignupNew.vue?vue&type=script&lang=js&"
export * from "./SignupNew.vue?vue&type=script&lang=js&"
import style0 from "./SignupNew.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SignupNew.vue?vue&type=style&index=1&id=10127a46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10127a46",
  null
  
)

export default component.exports